import Vue from 'vue'
export default Vue.filter('lowercase', value => value.toUpperCase())



// WEBPACK FOOTER //
// ./src/filters/string/lowercase.filter.js